export const OrdersRoutes = { path: 'order/*', lazy: () => import('../pages/orders') };
